/**
 * Redux에는 함수를 저장할 수 없으므로
 * 별도 Map으로 핸들러 관리
 *
 * key   : BackStack 아이템의 handlerKey
 * value : () => void
 */

const registry = new Map();

export const registerBackHandler = (key, handler) => {
  registry.set(key, handler);
};

export const unregisterBackHandler = (key) => {
  registry.delete(key);
};

export const runBackHandler = (key) => {
  const handler = registry.get(key);
  if (handler) {
    handler();
    return true;
  }
  console.warn(`[BackStack] 핸들러 없음: ${key}`);
  return false;
};
